
import React from 'react';
import { t } from '@superset-ui/core';
import {
    ControlPanelConfig,
    sections,
    sharedControls,
    ControlStateMapping,
    emitFilterControl,
    D3_FORMAT_OPTIONS,
} from '@superset-ui/chart-controls';
import { DEFAULT_FORM_DATA } from './types';
import { legendSection } from '../../../controls';
import { getSortOptions } from '../../utils';

const chartLegendSection = [...legendSection];
chartLegendSection.splice(2, 1);
 
const config: ControlPanelConfig = {
   controlPanelSections: [
     sections.legacyRegularTime,
     {
       label: t('Query'),
       expanded: true,
       controlSetRows: [
        [
          {
            name: 'groupby',
            config: {
              ...sharedControls.groupby,
              clearable: false,
              multi: false,
              label: t('Dimension'),
              description: t('Column values to use as categories.'),
            },
          },
        ],
        ['metrics'],
        ['adhoc_filters'],
        emitFilterControl,
        [
          {
              name: 'row_limit',
              config: {
              ...sharedControls.row_limit,
              default: 10,
              },
          },
        ]
       ],
     },
     {
       label: t('Chart Options'),
       expanded: true,
       controlSetRows: [
         ['color_scheme'],
         ...chartLegendSection,
         // eslint-disable-next-line react/jsx-key
         [<div className="section-header">{t('Labels')}</div>],
        
         [
           {
             name: 'smooth',
             config: {
               type: 'CheckboxControl',
               label: t('Smooth Line'),
               renderTrigger: true,
               default: DEFAULT_FORM_DATA.smooth,
               description: t('Whether to smooth the line graph.'),
             },
           },
         ],
         [
          {
            name: 'sortLabels',
            config: {
              type: 'SelectControl',
              label: t('Sort Labels'),
              choices: getSortOptions(),
              freeForm: false,
              renderTrigger: true,
              default: DEFAULT_FORM_DATA.sortLabels,
              description: t('Whether to sort the X-Axis labels.'),
            },
          },
        ],
        [
          {
            name: 'number_format',
            config: {
              type: 'SelectControl',
              freeForm: true,
              label: t('Number format'),
              renderTrigger: true,
              default: DEFAULT_FORM_DATA.numberFormat,
              choices: D3_FORMAT_OPTIONS,
              description: `${t(
                'D3 format syntax: https://github.com/d3/d3-format .',
              )} ${t('Applies to Y-Axis')}`,
            },
          },
        ],
        //  [
        //   {
        //     name: 'tooltipFormat',
        //     config: {
        //       ...commonControlsConfig.tooltipFormat,
        //       default: DEFAULT_FORM_DATA.tooltipFormat
        //     }
        //   }
        //  ]
         

       ],
     },
   ],
   onInit(state: ControlStateMapping) {
     return {
       ...state,
       row_limit: {
         ...state.row_limit,
         value: state.row_limit.default,
       },
     };
   },
   denormalizeFormData: formData => {
    return {
      ...formData,
      groupby: formData.standardizedFormData.standardizedState.columns,
      category: formData.category
    };
   },
   updateStandardizedState: (prevState, currState) => ({
     ...currState,
     metrics: [currState.metrics[0], ...prevState.metrics.slice(1)],
   }),
};
 
export default config;
 